













































import axios from 'axios'
import Logo from 'library/components/globals/logo'
import { makeCBDUrl } from 'library/services/helpers'
export LS_KEY = 'age-gate:passed'
export default

	components: {
		Logo
	}

	data: ->
		state: 'initial'
		showHelpText: false
		form:
			zip: null

	computed:
		iconClasses: -> 'active' if @showHelpText
		helpLabel: -> @$store.state.globals.siteGate?.label
		helpText: -> @$store.state.globals.siteGate?.helpText

		cbdHomeLink: -> makeCBDUrl '/'

		# Don't require the zip if the age gate is rendered on cbd/hemp sites
		isCbdSite: -> process.env.CMS_SITE in ['cbd', 'hemp']
		requireZip: -> !@isCbdSite

	methods:

		agree: ->
			localStorage.setItem LS_KEY, true
			if @requireZip
			then @state = 'continue' # Advance to zip screen
			else @close() # Close the age gate

		# If this is a CBD site and they click "no" to the age gate, bounce them
		# back to where they come from or to Google if that's unknown.  It's
		# expected that users on CBD sites will only encounter the gate if they
		# arrived here from ad traffic.
		disagree: ->
			if @isCbdSite
			then window.location = document.referrer || 'https://www.google.com'
			else @state = 'disagreed'

		toggleHelpText: -> @showHelpText = !@showHelpText

		submitZip: ->
			@$store.commit 'customer/setAgeGateZip', @form.zip
			@close()

		# Close the modal
		close: ->
			@$refs.modal.close()
			@$emit 'passed'

